// createNodeModuleContext.js — pending create module for top-level add flows

import { NODE_MODULE, normalizeNodeModule } from 'utilities/nodeModule';

const STORAGE_KEY = 'orbital.createNodeModule';

/**
 * Sets the module used for the next top-level node create.
 *
 * @param {'private'|'public'|null|undefined} moduleValue
 */
export function setPendingCreateNodeModule(moduleValue) {
  const normalized = normalizeNodeModule(moduleValue) || NODE_MODULE.PRIVATE;
  try {
    sessionStorage.setItem(STORAGE_KEY, normalized);
  } catch (_error) {
    // ignore
  }
}

/**
 * Reads and clears the pending create module (defaults to private).
 *
 * @returns {'private'|'public'}
 */
export function takePendingCreateNodeModule() {
  try {
    const value = normalizeNodeModule(sessionStorage.getItem(STORAGE_KEY));
    sessionStorage.removeItem(STORAGE_KEY);
    return value || NODE_MODULE.PRIVATE;
  } catch (_error) {
    return NODE_MODULE.PRIVATE;
  }
}

/**
 * Peeks without clearing (e.g. multi-file upload).
 *
 * @returns {'private'|'public'}
 */
export function peekPendingCreateNodeModule() {
  try {
    return normalizeNodeModule(sessionStorage.getItem(STORAGE_KEY)) || NODE_MODULE.PRIVATE;
  } catch (_error) {
    return NODE_MODULE.PRIVATE;
  }
}

/**
 * Resolves module for a create: URL ?module= wins, then pending context.
 *
 * @param {{ consume?: boolean }} [options]
 * @returns {'private'|'public'}
 */
export function resolveCreateNodeModule({ consume = false } = {}) {
  try {
    const fromUrl = normalizeNodeModule(
      new URLSearchParams(window.location.search).get('module'),
    );
    if (fromUrl) return fromUrl;
  } catch (_error) {
    // ignore
  }
  return consume ? takePendingCreateNodeModule() : peekPendingCreateNodeModule();
}
